
import "../Foundation/stylable/colors.st.css.js";
import "../Foundation/stylable/spacing.st.css.js";
import "../Foundation/stylable/shadows.st.css.js";
import "../Foundation/stylable/default-scroll-bar.st.css.js";
import "../Foundation/stylable/typography.st.css.js";
import "../Heading/Heading.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_209_0_MessageBoxFunctionalLayout";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_209_0_MessageBoxFunctionalLayout__root","defaultScrollBar":"wds_1_209_0_defaultscrollbar__defaultScrollBar","text-medium-thin":"wds_1_209_0_StylableTypography__text-medium-thin","topAreaContainer":"wds_1_209_0_MessageBoxFunctionalLayout__topAreaContainer","contentAreaContainer":"wds_1_209_0_MessageBoxFunctionalLayout__contentAreaContainer","imageContainer":"wds_1_209_0_MessageBoxFunctionalLayout__imageContainer","header":"wds_1_209_0_MessageBoxFunctionalLayout__header","heading":"wds_1_209_0_MessageBoxFunctionalLayout__heading","content":"wds_1_209_0_MessageBoxFunctionalLayout__content","contentWithImage":"wds_1_209_0_MessageBoxFunctionalLayout__contentWithImage","image":"wds_1_209_0_MessageBoxFunctionalLayout__image","footer":"wds_1_209_0_MessageBoxFunctionalLayout__footer","footerbuttons":"wds_1_209_0_MessageBoxFunctionalLayout__footerbuttons","bottomChildren":"wds_1_209_0_MessageBoxFunctionalLayout__bottomChildren","controlButtons":"wds_1_209_0_MessageBoxFunctionalLayout__controlButtons"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {}; 




